import { CustomerState, wrapStateWithCustomerNumber } from '../utils/url';
import { FetchSuccessMachinesPayload, Machine, MachineAction, MachineActions, MachineStatisticsWithdrawalsData, MachineStatisticsWithdrawalsSeries, MachineStatisticsWithdrawalsSeriesResponse, MachinesStatisticsWithdrawalsSeries } from '../model/customer-machine';
import { ResponsePayload } from '../model/request';
import createReducer from './createReducer';

export const customerMachines = createReducer<CustomerState<Machine[]>>({}, {
  [MachineActions.FETCH_CUSTOMER_MACHINES_SUCCESS](
    state: CustomerState<Machine[]>,
    action: MachineAction
  ) {
    return wrapStateWithCustomerNumber((action.payload as ResponsePayload<FetchSuccessMachinesPayload>).data, state, []);
  },
});

export const customerMachinesStatisticsWithdrawals = createReducer<CustomerState<MachinesStatisticsWithdrawalsSeries>>({}, {
  [MachineActions.FETCH_CUSTOMER_MACHINES_STATISTICS_WITHDRAWAL_SUCCESS](
    state: CustomerState<MachinesStatisticsWithdrawalsSeries>,
    action: MachineAction
  ) {
    return wrapStateWithCustomerNumber((action.payload as ResponsePayload<MachinesStatisticsWithdrawalsSeries>).data, state, undefined);
  },
});

export const customerMachineStatisticsWithdrawals = createReducer<CustomerState<MachineStatisticsWithdrawalsData>>({}, {
  [MachineActions.FETCH_CUSTOMER_MACHINE_STATISTICS_WITHDRAWAL_SUCCESS](
    state: CustomerState<MachineStatisticsWithdrawalsSeries>,
    action: MachineAction
  ) {
    return wrapStateWithCustomerNumber(oldState => {
      const { machineId, ...data } = (action.payload as ResponsePayload<MachineStatisticsWithdrawalsSeriesResponse>).data;
      return {
        ...(oldState || {}),
        [machineId]: data,
      }
    }, state, {});
  },
});